export default __webpack_public_path__ + "static/media/MyFeed.1dd3a6a3.svg";